import { ListColumn, ListColumnAlignment } from '@/interfaces'
import { computed } from 'vue'

const videoCols = computed<ListColumn[]>(() => {
  return [
    {
      name: 'title',
      title: 'content-video-title',
      width: 20,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      offset: 140,
      position: 1,
      priority: 1,
      expand: true
    },
    {
      name: 'upload_date',
      title: 'content-uploaded-date',
      width: 11,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 10,
      priority: 2,
      minWidthInPx: '150px'
    },
    {
      name: 'private',
      title: 'content-video-exposure',
      width: 10,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 5,
      priority: 6
    },
    // {
    //   name: 'views',
    //   title: 'dashboard-content-content_views',
    //   width: 6,
    //   alignment: ListColumnAlignment.Center,
    //   sortable: false,
    //   position: 6,
    //   priority: 8
    // },
    {
      name: 'likes',
      title: 'content-likes',
      width: 6,
      alignment: ListColumnAlignment.Center,
      sortable: false,
      position: 7,
      priority: 8
    },
    {
      name: 'shares',
      title: 'content-shares',
      width: 6,
      alignment: ListColumnAlignment.Center,
      sortable: false,
      position: 8,
      priority: 8
    },
    {
      name: 'pricing_model',
      title: 'content-payment-type',
      width: 12,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 9,
      priority: 7
    },
    {
      name: 'language_id',
      title: 'settings-content-content-sources-language',
      width: 11,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 3,
      priority: 4
    },
    {
      name: 'is_vertical',
      title: 'settings-content-content-sources-orientation',
      width: 9,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 4,
      priority: 5
    },
    {
      name: 'duration_in_ms',
      title: 'library-filters-duration',
      width: 8,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 2,
      priority: 3
    },
    {
      name: 'actions',
      title: '',
      width: 12,
      alignment: ListColumnAlignment.Center,
      position: 11,
      priority: 0,
      minWidthInPx: '160px'
    }
  ]
})

export default videoCols
